export default "__VITE_ASSET__DleTGORp__"